import { React, useState, useRef, forwardRef, useImperativeHandle, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import FetchModule from '../../Model/Share/Network/FetchModule';
import { formatPhoneNumber } from '../../Utils/phoneUtils';

import SearchImgPath from '../../image/SearchIcon.png';
import SearchInputCheck from '../../image/MemberShipSearchInputCheck.png';

const LockerMemberSearchInput = forwardRef((props, ref) => {
	const { className, placeholder, type } = props;

  const history = useHistory();
  const { t, languageMode } = useLanguage();

	const [value, setValue] = useState('');
  const [dataList, setDataList] = useState([]);
  const [data, setData] = useState([]);
  const [index, setIndex] = useState(-1);
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
      if (index === -1) return 'None';
      else return dataList[index];
		},
    getDataList: () => {
      return dataList;
    },
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = '#FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = '#E8E8E8';
		}
	}));

  // 라커 사용 가능 회원 목록 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
		(
			async () => {
				const responseData = await fetchModule.getDataVersion2('locker/available/member/', 'GET');

        if (responseData.status === 200) {
          const tmpList = responseData.data.slice();

          for (let i = 0; i < tmpList.length; i++) {
            tmpList[i] = Object.assign(tmpList[i], { isChecked: false })
          }
          setData(tmpList);
          setDataList(tmpList);
        }
        else if (responseData.status === 401) history.push('/');
			}
		)();
  }, [history])

	function handleClick(index) {
    const tmpList = dataList.slice();

		for (let i = 0; i < dataList.length; i++) {
      tmpList[i].isChecked = false;
    }

    tmpList[index].isChecked = true;

    setDataList(tmpList);
    setIndex(index);
	}

	function handleChange(e) {
		setValue(e.target.value);

    const indexList = [];
    const tmp = [];
    for (let i = 0; i < data.length; i++) {
      if (data[i].name.indexOf(e.target.value) > -1) {
        indexList.push(i);
      }
      else if (data[i].phone.indexOf(e.target.value) > -1){
        indexList.push(i);
      }
    }

    if (indexList.length !== 0) {
      for (let i = 0; i < indexList.length; i++) {
        tmp.push(data[indexList[i]]);
      }
      setDataList(tmp);
    }
    else {
      setDataList(data);
    }
	}

	function handleFocus(e) {
		setChangedPlaceholderColor(false);
		if (!changed) {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#E8E8E8';
	}

  function decidePhoneView(phone, countryCode) {
    return formatPhoneNumber(phone, countryCode, languageMode) || t('main.locker.noPhone');
  }

  return (
    <TopLevelWrapper>
      <SearchWrapper>
        <Input
          ref={inputRef}
          img={SearchImgPath}
          clickCount={clickCount}
          type={type}
          placeholder={t('main.locker.searchPlaceholder')}
          value={'' || value}
          changedColor={changedPlaceholderColor}
          className={`${className} ${changed ? "changed" : ""}`}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur} />
        <InfoWrapper>
          {
            dataList.map((data, index) => (
              <InfoBox key={'LockerMemberSearch-' + index} onClick={() => handleClick(index)}>
                <Table>
                  <Body>
                    <Tr>
                      <Td>
                        <TextWrapper style={{ width: `57px` }}>
                          <Name isChecked={data.isChecked}>{data.name}</Name>
                        </TextWrapper>
                      </Td>
                    </Tr>
                    <Tr>
                      <Td>
                        <TextWrapper style={{ width: `100px`, marginLeft: `10px`}}>
                          <Phone isChecked={data.isChecked} style={{ width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{decidePhoneView(data.phone, data.countryCode)}</Phone>
                        </TextWrapper>
                      </Td>
                    </Tr>
                  </Body>
                </Table>
                <CheckImg src={SearchInputCheck} opacity={data.isChecked ? 1 : 0}/>
              </InfoBox>
            ))
          }
        </InfoWrapper>
      </SearchWrapper>
    </TopLevelWrapper>
  )
})

export default LockerMemberSearchInput;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: flex-start;
`;

const SearchWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 12px;
	line-height: 20px;

  padding: 0 0 0 40px;
  width: 223px;
  height: 40px;

	outline: none;
  border: 1px solid #DFDFDF;
  border-radius: 5px;
	color: #000000;

  background: url(${props => props.img}) no-repeat 8px center;

	::placeholder {
		color: ${props => props.changedColor ? `#FF3131` : `#CBCBCB`};
	}

  transition: all 0.3s ease-in-out;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 265px;
  height: 124px;

  overflow-y: scroll;

  margin-top: 16px;

  &::-webkit-scrollbar {
		width: 9px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.scrollBar};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 26px;

  border-bottom: 1px solid #F5F5F5;

  &:hover {
    cursor: pointer;
  }
`;

const Table = styled.table`
  display: flex;
  flex-direction: row;

  height: 32px;
`;

const Body = styled.tbody`
  display: flex;
  flex-direction: row;
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;
`;

const Td = styled.td`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  overflow: hidden;

  max-height: 20px;
`;

const Name = styled.span`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color:  ${props => props.isChecked ? `#FF8B48` : `#595959`};

  margin: 0 0 0 0;

  transition: all 0.2s ease-in-out;
`;

const Phone = styled.span`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.isChecked ? `#FF8B48` : `#777777`};

  margin: 0 0 0 0;

  transition: all 0.2s ease-in-out;
`;

const CheckImg = styled.img`
  width: 12px;
  height: 9px;

  opacity: ${props => props.opacity};

  transition: all 0.2s ease-in-out;
`;
